module.exports = __webpack_public_path__ + "static/media/kostel-celek.7cd29943.jpg";